// Diwali Sale 2026 — flat $99 lehengas & shararas.
export const DIWALI_ENDS = new Date("2026-11-08T23:59:59-06:00").getTime(); // Diwali night (Chicago)

export const DIWALI = {
  night: "#160410", // deep festive night backdrop
  maroon: "#3D0A28",
  gold: "#F5C542",
  ember: "#FF8C42",
};
